var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Hide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99971 6.4812C7.10817 6.4812 6.39038 7.19903 6.39038 8.09187C6.39038 8.53697 6.56697 8.93119 6.86029 9.22401C7.05573 9.4191 7.056 9.73568 6.86091 9.93111C6.66582 10.1265 6.34923 10.1268 6.1538 9.93173C5.68046 9.45921 5.39038 8.81344 5.39038 8.09187C5.39038 6.64737 6.55526 5.4812 7.99971 5.4812C8.71325 5.4812 9.37317 5.77009 9.84272 6.24712C10.0364 6.44392 10.0339 6.76049 9.83713 6.9542C9.64033 7.14792 9.32376 7.14542 9.13004 6.94862C8.84626 6.66031 8.44217 6.4812 7.99971 6.4812Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1584 7.9738C10.4302 8.02268 10.6109 8.28263 10.562 8.55441C10.3704 9.61963 9.53263 10.4592 8.46787 10.6525C8.19617 10.7019 7.93593 10.5216 7.88661 10.2499C7.83728 9.97818 8.01756 9.71794 8.28926 9.66861C8.94316 9.54991 9.46004 9.03218 9.57779 8.3774C9.62667 8.10562 9.88662 7.92492 10.1584 7.9738Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99974 3.72278C6.85849 3.72278 5.74513 4.13196 4.76603 4.90685L4.76483 4.90779L4.76483 4.90779C3.82217 5.64917 2.99984 6.72807 2.37969 8.09199C2.99344 9.44863 3.80962 10.5203 4.74517 11.2548C4.96237 11.4254 5.0002 11.7397 4.82967 11.9569C4.65914 12.1741 4.34483 12.2119 4.12763 12.0414C2.99219 11.1499 2.04962 9.86349 1.37361 8.28867C1.31941 8.16241 1.31956 8.0194 1.37403 7.89325C2.05656 6.31246 3.00472 5.02005 4.14603 4.12224C5.2828 3.22276 6.61055 2.72278 7.99974 2.72278C9.39824 2.72278 10.7254 3.2308 11.8675 4.13551C12.084 4.30697 12.1205 4.62144 11.949 4.8379C11.7775 5.05437 11.4631 5.09084 11.2466 4.91938C10.2594 4.13742 9.14656 3.72278 7.99974 3.72278Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6644 5.59433C12.885 5.42826 13.1985 5.47248 13.3645 5.6931C13.8495 6.33739 14.272 7.07575 14.6253 7.89267C14.68 8.01921 14.6801 8.16272 14.6254 8.28929C13.2642 11.4429 10.8018 13.4591 7.99972 13.4591C7.36993 13.4591 6.74918 13.3569 6.15343 13.1581C5.89149 13.0707 5.75002 12.7875 5.83744 12.5255C5.92486 12.2636 6.20807 12.1221 6.47001 12.2095C6.96493 12.3747 7.47884 12.4591 7.99972 12.4591C10.2217 12.4591 12.3466 10.8896 13.6195 8.09128C13.3135 7.41931 12.9596 6.81791 12.5656 6.2945C12.3995 6.07388 12.4437 5.7604 12.6644 5.59433Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6116 2.47945C13.8068 2.67472 13.8068 2.9913 13.6116 3.18656L3.09556 13.7026C2.9003 13.8978 2.58371 13.8978 2.38845 13.7026C2.19319 13.5073 2.19319 13.1907 2.38845 12.9955L12.9045 2.47945C13.0997 2.28419 13.4163 2.28419 13.6116 2.47945Z",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/VisibilityOff.11801d46141e4b6bfc6c6d8c82e8b202.svg";
export { ForwardRef as ReactComponent };